/**
 * Logger Utility
 * Centralized logging for Odisha Zaika application
 * Logs only in development mode, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

class Logger {
  /**
   * Log info messages (development only)
   */
  info(...args) {
    if (isDevelopment) {
      console.log(...args);
    }
  }

  /**
   * Log warning messages (development only)
   */
  warn(...args) {
    if (isDevelopment) {
      console.warn(...args);
    }
  }

  /**
   * Log error messages (always logged, but can be sent to error tracking service)
   */
  error(...args) {
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, send to error tracking service (e.g., Sentry)
      // For now, we'll log to console.error but this can be replaced
      console.error(...args);
    }
  }

  /**
   * Log debug messages (development only)
   */
  debug(...args) {
    if (isDevelopment) {
      console.debug(...args);
    }
  }

  /**
   * Log table data (development only)
   */
  table(data) {
    if (isDevelopment && console.table) {
      console.table(data);
    }
  }

  /**
   * Group logs (development only)
   */
  group(label) {
    if (isDevelopment && console.group) {
      console.group(label);
    }
  }

  /**
   * End log group (development only)
   */
  groupEnd() {
    if (isDevelopment && console.groupEnd) {
      console.groupEnd();
    }
  }

  /**
   * Time execution (development only)
   */
  time(label) {
    if (isDevelopment && console.time) {
      console.time(label);
    }
  }

  /**
   * End time execution (development only)
   */
  timeEnd(label) {
    if (isDevelopment && console.timeEnd) {
      console.timeEnd(label);
    }
  }
}

// Export singleton instance
const logger = new Logger();

export default logger;
